import * as fzstd from 'fzstd';

import { MessageContent } from './notification';

// 消息编解码
class MessageCodec {
  private enableDecompression: boolean;

  constructor(enableDecompression: boolean = true) {
    this.enableDecompression = enableDecompression;
  }

  // fzstd 不支持压缩，这里只传未压缩的版本
  encode(content: MessageContent): Uint8Array {
    return MessageContent.encode(content).finish();
  }

  // 尝试解压数据，如果不支持解压，直接返回原始数据
  decode(data: Uint8Array): MessageContent {
    let decoded = data;

    if (this.enableDecompression && this.isCompressed(data)) {
      try {
        decoded = fzstd.decompress(data);
      } catch (err) {
        console.warn('Decompression failed, using raw data:', err);
      }
    }

    return MessageContent.decode(decoded);
  }

  // 一个简单的判断，用来判断是否是压缩数据
  // Zstd magic number: 0x28, 0xB5, 0x2F, 0xFD
  isCompressed(data: Uint8Array): boolean {
    return data.length >= 4 && data[0] === 0x28 && data[1] === 0xb5 && data[2] === 0x2f && data[3] === 0xfd;
  }
}

export default MessageCodec;
